import React from "react";
import { connect } from "react-redux";
import { compose, lifecycle } from "recompose";

import Card from "react-md/lib/Cards/Card";
import CardText from "react-md/lib/Cards/CardText";

import Header from "../components/ContainerHeader";
import RequestNewReceivedForm from "../components/requestNewReceived/RequestNewReceivedForm";

import {
  getProjects,
  getAdminDispatcherOrganizations
} from "../actions/resourceActions";
import { getUser } from "../actions/userActions";
import {TouchPageHeader, TouchPageHeader_and_content_spaceBetween} from "../AtollonTheme/ReactElements";

const RequestReceived = ({ history, user, data }) => {
  return (
    <div className="flex-col">

      <TouchPageHeader title="Nový přijatý požadavek" />
      <TouchPageHeader_and_content_spaceBetween heightPx={50}/>

      {user && (
        <Card>
          <CardText>
            <RequestNewReceivedForm
              initialValues={{
                requestType: "RECEIVED",
                priceCurrency: "CZK",
                withOrWithoutTax: "WITHOUT_TAX",
                to: user.identifier,
                sender: data && data.sender ? data.sender : undefined,
                customType: "Obecné",
                severity: "5",
                project: "NO_PROJECT",
                messageBody: ""
              }}
              user={user}
              history={history}
            />
          </CardText>
        </Card>
      )}
    </div>
  );
};

export default compose(
  connect(({ app: { user, data } }) => ({ user, data }), {
    getProjects,
    getAdminDispatcherOrganizations,
    getUser
  }),
  lifecycle({
    async componentWillMount() {
      const {
        getProjects,
        getAdminDispatcherOrganizations,
        getUser
      } = this.props;

      getProjects();
      getAdminDispatcherOrganizations();
      getUser();
    }
  })
)(RequestReceived);



// WEBPACK FOOTER //
// ./src/pages/RequestReceived.js